import * as actionTypes from '../actions/types';

const initialState = {
    filtro: null,
    estados: [],
    presentaciones: [],
    filasPorPagina: 10,
    paginaActual: 0,
    cantidadTotal: 0,
    fetching: false,
    filtroActivo: false,
};

export function grillaPrincipalReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.ACTUALIZAR_ATRIBUTOS_GRILLA:
            return {
                ...state,
                ...action.payload,
            };
        case actionTypes.SET_FILTRO_GRILLA:
            return {
                ...state,
                filtro: { ...state.filtro, ...action.payload },
            };
        case actionTypes.SET_PRESENTACIONES:
            return {
                ...state,
                presentaciones: [...action.payload],
            };
        case actionTypes.SET_ESTADOS_FILTRO:
            return {
                ...state,
                estados: [...action.payload],
            };
        default:
            return state;
    }
}
